import { memo } from 'react'
import { HOME_TUTOR_UNIV_ROW_BOTTOM_IMG_LIST, HOME_TUTOR_UNIV_ROW_TOP_IMG_LIST } from '../../../data/home.data'

type TutorUniversityListProps = {
  showTopList: boolean
  showBottomList: boolean
}

const TutorUniversityList: React.FC<TutorUniversityListProps> = ({ showTopList = true, showBottomList = true }) => {
  return (
    <div className="relative mt-[17px] w-full overflow-hidden">
      {/* Top Marquee */}
      {showTopList && (
        <div className="marquee_anim_v2 top relative mb-16 flex items-center">
          <div className="marquee_item flex items-center justify-start">
            {HOME_TUTOR_UNIV_ROW_TOP_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12 h-[60px] w-full" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
            {HOME_TUTOR_UNIV_ROW_TOP_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12 h-[60px] w-full" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
            {HOME_TUTOR_UNIV_ROW_TOP_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12 h-[60px] w-full" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
          </div>
        </div>
      )}

      {/* Bottom Marquee */}
      {showBottomList && (
        <div className="marquee_anim_v2 bottom relative mb-16 flex items-center">
          <div className="marquee_item flex items-center justify-start pl-[56px]">
            {HOME_TUTOR_UNIV_ROW_BOTTOM_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
            {HOME_TUTOR_UNIV_ROW_BOTTOM_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
            {HOME_TUTOR_UNIV_ROW_BOTTOM_IMG_LIST.map((imgUrl, i) => (
              <img src={imgUrl} className="mr-12" key={`${i}-uni-top`} alt={`uni-logo-${i}`} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default memo(TutorUniversityList)
